import styled from '@emotion/styled';

export const mobileHeaderSize = '50px';
export const Container = styled.div`
    height: ${mobileHeaderSize};
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: ${({ theme }) => theme.base.color.backgroundBar};
`;

export const ScrollableView = styled.div`
    margin-top: ${mobileHeaderSize};
`;
